import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const NewHampshire = () => {
  return (
    <StatePropertyTaxPage
      stateName="New Hampshire"
      processDescription="Property owners may appeal their assessment by filing with the local board of tax and land appeals or the Board of Tax and Land Appeals (BTLA). Appeals should include evidence supporting the property owner's valuation."
      noticeOfValueMailed="April"
      noticeOfValueMailedDateExplanation="Assessment notices are typically mailed in April, giving property owners time to review their assessments before the appeal deadline."
      valuationAsOfDate="April 1"
      valuationAsOfDateExplanation="New Hampshire assesses property as of April 1 each year. This spring assessment date captures property values after winter conditions but before peak summer real estate activity."
      deadlineExplanation="Property owners typically have until September 1st to file appeals with the local assessor, or until December 1st to file with the Board of Tax and Land Appeals."
    />
  );
};

export default NewHampshire;